import React, { useState } from "react";
import { X } from 'lucide-react';

const AddAuthorWidgetPopup = ({ onAdd, onClose }) => {
    const [title, setTitle] = useState("");
    const [prompt, setPrompt] = useState("");
    const [chartQuery, setChartQuery] = useState("");
    const [isVisualization, setIsVisualization] = useState(false);

    const handleSubmit = () => {
        if (title && prompt && (!isVisualization || chartQuery)) {
            onAdd({
                title,
                prompt,
                chartQuery: isVisualization ? chartQuery : ""
            });
            resetForm();
        }
    };

    const resetForm = () => {
        setTitle("");
        setPrompt("");
        setChartQuery("");
        setIsVisualization(false);
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex justify-center items-center z-[1000] backdrop-blur-sm">
            <div className="bg-white rounded-lg p-6 w-[500px] max-w-[90%] shadow-xl border border-gray-200 animate-fadeInUp">
                <div className="flex justify-between items-center mb-4">
                    <h2 className="text-xl font-semibold text-gray-800">Add Widget</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-500 hover:text-gray-700 transition-colors"
                    >
                        <X size={20} />
                    </button>
                </div>

                <div className="space-y-4">
                    <div>
                        <label htmlFor="widget-title" className="block mb-1.5 text-sm font-medium text-gray-700">
                            Title
                        </label>
                        <input
                            id="widget-title"
                            type="text"
                            placeholder="Widget title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm transition-all bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white"
                        />
                    </div>

                    <div>
                        <label className="block mb-1.5 text-sm font-medium text-gray-700">
                            Widget Type
                        </label>
                        <div className="flex gap-5 py-2">
                            <label className="flex items-center text-sm font-normal cursor-pointer">
                                <input
                                    type="radio"
                                    name="widgetType"
                                    value="plainText"
                                    checked={!isVisualization}
                                    onChange={() => setIsVisualization(false)}
                                    className="mr-1.5 accent-blue-600 cursor-pointer"
                                />
                                Plain Text
                            </label>
                            <label className="flex items-center text-sm font-normal cursor-pointer">
                                <input
                                    type="radio"
                                    name="widgetType"
                                    value="visualization"
                                    checked={isVisualization}
                                    onChange={() => setIsVisualization(true)}
                                    className="mr-1.5 accent-blue-600 cursor-pointer"
                                />
                                Visualization
                            </label>
                        </div>
                    </div>

                    <div>
                        <label htmlFor="widget-prompt" className="block mb-1.5 text-sm font-medium text-gray-700">
                            Prompt
                        </label>
                        <textarea
                            id="widget-prompt"
                            placeholder="Enter prompt for content generation"
                            value={prompt}
                            onChange={(e) => setPrompt(e.target.value)}
                            rows={3}
                            className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm transition-all bg-gray-50 resize-y min-h-[80px] focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white"
                        />
                    </div>

                    {isVisualization && (
                        <div>
                            <label htmlFor="chart-prompt" className="block mb-1.5 text-sm font-medium text-gray-700">
                                Chart Prompt
                            </label>
                            <textarea
                                id="chart-prompt"
                                placeholder="Enter prompt for chart visualization"
                                value={chartQuery}
                                onChange={(e) => setChartQuery(e.target.value)}
                                rows={3}
                                className="w-full px-3 py-2.5 border border-gray-300 rounded-md text-sm transition-all bg-gray-50 resize-y min-h-[80px] focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:bg-white"
                            />
                        </div>
                    )}
                </div>

                <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
                    <button
                        onClick={onClose}
                        className="px-4 py-2 bg-gray-100 text-gray-600 rounded-md font-medium text-sm transition-all hover:bg-gray-200"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleSubmit}
                        className={`px-4 py-2 bg-blue-600 text-white rounded-md font-medium text-sm transition-all ${!title || !prompt || (isVisualization && !chartQuery)
                                ? 'opacity-60 cursor-not-allowed'
                                : 'hover:bg-blue-700'
                            }`}
                        disabled={!title || !prompt || (isVisualization && !chartQuery)}
                    >
                        Add Widget
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddAuthorWidgetPopup;